
export function coupleRequestCheck(pic, callback) {
	return {
		type: "COUPLE_REQUEST_CHECK",
		payload: {
			pic: pic,
		},
		callback: callback,
	}
}

export function coupleRequestAdd(pic, callback) {
	return {
		type: "COUPLE_REQUEST_ADD",
		payload: {
			pic: pic,
		},
		callback: callback,
	}
}

export function coupleRequestDel() {
	return {
		type: "COUPLE_REQUEST_DEL",
	}
}


export function coupleReceptionOkCheck(couple_id, callback) {
	return {
		type: "COUPLE_RECEPTION_OK_CHECK",
		payload: {
			couple_id: couple_id,
		},
		callback: callback,
	}
}


export function coupleReceptionOk(couple_id, callback) {
	return {
		type: "COUPLE_RECEPTION_OK",
		payload: {
			couple_id: couple_id,
		},
		callback: callback,
	}
}


export function coupleReceptionNg(couple_id) {
	return {
		type: "COUPLE_RECEPTION_NG",
		payload: {
			couple_id: couple_id,
		},
	}
}

export function coupleRelease(callback) {
	return {
		type: "COUPLE_RELEASE",
		callback: callback,
	}
}
